export const removeNumberOfPlatesFromTaskName = (
  input: string,
  numberOfPlates: number
): string => {
  const pattern = new RegExp(`:\\s*${numberOfPlates}\\s+Plate\\(s\\)`, "g");
  return input.replace(pattern, "").trim();
};